import BaseDebounceLink from 'apollo-link-debounce';

const DEFAULT_DEBOUNCE_TIMEOUT = 200;

export const DebounceLink = new BaseDebounceLink(DEFAULT_DEBOUNCE_TIMEOUT);
